import { createIcon } from '@chakra-ui/react';

export const Onvif = createIcon({
  displayName: 'Onvif',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M21,2H3C2.45,2,2,2.45,2,3v5.76c0,0.16,0.04,0.31,0.11,0.45l1.62,3.23c0.07,0.14,0.17,0.25,0.29,0.34
C4.01,12.86,4,12.93,4,13c0,4.42,3.58,8,8,8s8-3.58,8-8c0-0.07-0.01-0.14-0.01-0.22c0.12-0.09,0.22-0.2,0.29-0.34l1.62-3.23
C21.96,9.07,22,8.92,22,8.76V3C22,2.45,21.55,2,21,2z M12,20c-3.86,0-7-3.14-7-7h1c0,1.81,0.81,3.44,2.08,4.54
C8.03,17.37,8,17.19,8,17c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.85-0.53,1.57-1.28,1.86C11.13,18.95,11.56,19,12,19c3.31,0,6-2.69,6-6h1
C19,16.86,15.86,20,12,20z M21,8.77L19.38,12L4.62,12L3.37,9.5H19c0.28,0,0.5-0.22,0.5-0.5S19.28,8.5,19,8.5H3L3,3h18l0,0L21,8.77z
"
    />
  ),
});
